import React, { useState } from 'react'
import { useStoreState } from 'easy-peasy'
import { useQuery, useMutation } from 'react-apollo-hooks'
import { Text } from 'rebass'
import get from 'lodash.get'

import { Form, TextInput } from '../Form'
import Card from '../Card'
import Loading from '../Loading'

import { updateAccountCTA } from '../../utilities/validations'
import queries from '../../queries'
import mutations from '../../mutations'

const CTA = ({ admin }) => {
  const accountId = useStoreState(state => state.account.id)
  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(null)
  const { data, error: queryError, loading } = useQuery(queries.users.BUSINESS, {
    suspend: false,
    fetchPolicy: 'network-only',
    variables: { accountId },
  })
  const [updateAccount] = useMutation(mutations.users.CTA)

  const onSubmit = async (values, { setSubmitting }) => {
    setSubmitting(true)
    setError(null)
    setSuccess(null)

    const variables = {
      ...updateAccountCTA.cast(values),
      id: accountId,
    }

    try {
      await updateAccount({ variables })
      setSuccess('Your account was updated')
    } catch (e) {
      setError(e.message)
    }

    setSubmitting(false)
  }

  if (queryError && queryError.message) return <Text color="error">{queryError.message}</Text>

  return (
    <Card
      heading="Call to Action"
      text="Give your customers a way to view your website, menu, etc."
    >
      {loading
        ? <Loading />
        : (
          <Form
            initialValues={{
              ctaText: get(data, 'account[0].cta_text', '') || '',
              ctaUrl: get(data, 'account[0].cta_url', '') || '',
            }}
            validationSchema={updateAccountCTA}
            onSubmit={onSubmit}
            success={success}
            error={error}
            canSubmit={admin}
          >
            <TextInput name="ctaText" placeholder="Enter a call to action" label="Call to Action" disabled={!admin} />
            <TextInput name="ctaUrl" placeholder="Enter a URL" label="URL" disabled={!admin} />
          </Form>
        )
      }
    </Card>
  )
}

export default CTA
